import React, { useEffect, useState } from "react";
import "./TheParentDashboard.css";
import StudentBio from "./StudentBio";
import StudentPapersStatus from "./StudentPapersStatus";
import AvailablePapers from "./AvailablePapers";
import Child from './imageFiles/Child.png';

export default function StudentDetails({studentData, availablePapers, grades, parent_dashboard_initial_loading, parent_dashboard_data_loading}) {

  const [activeTab, setActiveTab] = useState(null);
  const [activeStudent, setActiveStudent] = useState(null);

  useEffect(() => {
    if (studentData && studentData.length > 0) {      
      setActiveTab(studentData[0].stu_id);
      setActiveStudent(studentData[0]);
    }
  }, [studentData]);

 
  useEffect(() => {

    if(activeTab && studentData){
      const selected = studentData?.find(s => s.stu_id === activeTab);
      setActiveStudent(selected);
    }
    
  }, [activeTab, studentData]);

  const findGrade = (grade_id) => {
  
      if (grades && grades.length > 0 && grade_id) {
        const studentGrade = grades?.find((grade) => grade.grade_id === parseInt(grade_id));
  
        return studentGrade ? String(studentGrade.grade) : "--"
      }
      else {
        return "--"
      }
    }

  return (
    <div className="student-details-section card p-3">

      <div className="student-tab-header d-flex align-items-center justify-content-between mb-3">
        <div className="left-icon-btn">
          <button className="circle-btn">
            <i className="fas fa-sort-down rotate-90" />
          </button>
        </div>
        <div className="tab-list d-flex justify-content-center flex-grow-1">
          {studentData?.length > 0 && !parent_dashboard_data_loading ? (
            studentData?.map((student,index) => (
                <div
                  key={student.stu_id}
                  className={`tab-item ${activeTab === student.stu_id ? "active-tab" : ""}`}
                  onClick={() => setActiveTab(student.stu_id)}
                >
                  {student?.first_name || "N/A"}
                </div>
              ))
            ):(
              parent_dashboard_data_loading || parent_dashboard_initial_loading?(
                <div className="tab-item">Loading...</div>
              ):(
              <div className="tab-item">No Students</div>
              )
              
            )
          }
          { }
        </div>
        <div className="right-icon-btn">
          <button className="circle-btn">
            <i className="fas fa-sort-up rotate-90" />
          </button>
        </div>
      </div>

      
        <div className="tab-body-content mt-4">
          {!parent_dashboard_initial_loading && !parent_dashboard_data_loading && activeStudent ? (
            <div className="row g-3 align-items-start">
              <div className="col-lg-4 col-md-12">
                <StudentBio
                  name={`${activeStudent?.first_name} ${activeStudent?.last_name}`}
                  grade={findGrade(activeStudent?.grade)}
                  school={activeStudent?.school}
                  email={activeStudent?.email}
                  credit={activeStudent?.available_credits_count || 0}
                  avatar={Child}
                  parent_dashboard_initial_loading={parent_dashboard_initial_loading}
                />
              </div>

              <div className="col-lg-8 col-md-12">
                <StudentPapersStatus papers={activeStudent?.enrolled_papers || []} parent_dashboard_initial_loading={parent_dashboard_initial_loading}/>
              </div>
            </div>
          ):(
            parent_dashboard_initial_loading || parent_dashboard_data_loading ?(
              <div className="row g-3 align-items-start">
                <div className="col-lg-4 col-md-12">
                  Loading...
                </div>
                <div className="col-lg-8 col-md-12">
                  Loading...
                </div>
              </div>
            ):(
              <div className="row g-3 align-items-start">
                <div className="col-lg-4 col-md-12">
                  No Data
                </div>
                <div className="col-lg-8 col-md-12">
                  No Data
                </div>
              </div>
            )
          )}
          <AvailablePapers 
            availablePapers={availablePapers} 
            parent_dashboard_initial_loading={parent_dashboard_initial_loading}
            parent_dashboard_data_loading={parent_dashboard_data_loading}
          />
        </div>
      
    </div>
  );
}
